<div id="modal-infinite-spinner">
    <div class="d-flex align-items-center justify-content-center h-100">
      <div class="text-center">
        <div class="icons">
          <div class="spinner-border" role="status"></div>
        </div>
        <h3>{{mensaje}}</h3>
      </div>
    </div>
  </div>  